<template>
  <LotteryBasePlaySlip>
    <template #default="{ isDisabled, isVisible, play, updatePlays }">
      <slot v-bind="{ isDisabled, isVisible, play, updatePlays }">
        <PowerballXsAndOsBasePlaySlipItem
          v-if="isVisible || !isDisabled"
          v-bind="{ play }"
          :disabled="isDisabled"
          @play-state-changed="updatePlays"
        />
        <LotteryPlaySlipItemSkeleton v-else height="20vh" />
      </slot>
    </template>

    <template #bottom>
      <slot name="bottom" />
    </template>
  </LotteryBasePlaySlip>
</template>
